import {
    Box,
    Divider,
    Fade
} from "@mui/material";
import { useEffect, useState } from "react";
import DrawerCommonContent from "./DrawerCommonContent";
import DrawerSpecificContent from "./DrawerSpecificContent";
import DrawerUpperContent from "./DrawerUpperContent";

const DrawerContent = ({ data, isMobile }) => {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        // Smooth entrance animation
        const timer = setTimeout(() => setIsLoaded(true), 100);
        return () => clearTimeout(timer);
    }, []);

    return (
        <Fade in={isLoaded} timeout={600}>
            <Box sx={{
                height: '100%',
                background: 'transparent',
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                // Modern scrolling behavior
                scrollBehavior: 'smooth',
            }}>
                {/* Header section - enhanced with glass effect - only show on desktop */}
                {(
                    <>
                        <Box
                            sx={{
                                flexShrink: 0,
                                background: (theme) => theme.palette.mode === 'dark'
                                    ? 'linear-gradient(180deg, rgba(18, 18, 18, 0.98) 0%, rgba(18, 18, 18, 0.95) 100%)'
                                    : 'linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(255, 255, 255, 0.95) 100%)',
                                // backdropFilter: 'blur(12px)',
                                borderBottom: (theme) => theme.palette.mode === 'dark'
                                    ? '1px solid rgba(255, 255, 255, 0.08)'
                                    : '1px solid rgba(0, 0, 0, 0.06)',
                                zIndex: 1,
                                // Subtle shadow to create depth
                                boxShadow: (theme) => theme.palette.mode === 'dark'
                                    ? '0 2px 16px rgba(0, 0, 0, 0.3)'
                                    : '0 2px 16px rgba(0, 0, 0, 0.08)',
                            }}
                        >
                            <DrawerUpperContent data={data} isMobile={isMobile} />
                        </Box>
                        
                        {/* Enhanced divider with gradient effect */}
                        <Divider sx={{
                            background: (theme) => theme.palette.mode === 'dark'
                                ? 'linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.12) 50%, transparent 100%)'
                                : 'linear-gradient(90deg, transparent 0%, rgba(0, 0, 0, 0.08) 50%, transparent 100%)',
                            height: '1px',
                            border: 'none',
                            mx: 2,
                            my: 0.5,
                        }} />
                    </>
                )}
                
                {/* Main navigation content - enhanced scrolling */}
                <Box sx={{ 
                    flex: 1, 
                    overflow: 'hidden',
                    position: 'relative',
                    minHeight: 0,
                }}>
                    <Box
                        sx={{
                            height: '100%',
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            px: 1,
                            py: 0.5,
                            // Enhanced scrolling experience
                            scrollBehavior: 'smooth',
                            '&::-webkit-scrollbar': {
                                width: '4px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: 'transparent',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: (theme) => theme.palette.mode === 'dark'
                                    ? 'rgba(255, 255, 255, 0.15)'
                                    : 'rgba(0, 0, 0, 0.15)',
                                borderRadius: '2px',
                                '&:hover': {
                                    background: (theme) => theme.palette.mode === 'dark'
                                        ? 'rgba(255, 255, 255, 0.25)'
                                        : 'rgba(0, 0, 0, 0.25)',
                                }
                            }
                        }}
                    >
                        <DrawerSpecificContent data={data} />
                    </Box>
                </Box>
                
                {/* Enhanced bottom divider */}
                <Divider sx={{
                    background: (theme) => theme.palette.mode === 'dark'
                        ? 'linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.12) 50%, transparent 100%)'
                        : 'linear-gradient(90deg, transparent 0%, rgba(0, 0, 0, 0.08) 50%, transparent 100%)',
                    height: '1px',
                    border: 'none',
                    mx: 2,
                    mt: 0,
                    mb: 0.5,
                }} />
                
                {/* Footer section - enhanced with glass effect */}
                <Box
                    sx={{
                        flexShrink: 0,
                        background: (theme) => theme.palette.mode === 'dark'
                            ? 'linear-gradient(0deg, rgba(18, 18, 18, 0.98) 0%, rgba(18, 18, 18, 0.95) 100%)'
                            : 'linear-gradient(0deg, rgba(255, 255, 255, 0.98) 0%, rgba(255, 255, 255, 0.95) 100%)',
                        // backdropFilter: 'blur(8px)',
                        borderTop: (theme) => theme.palette.mode === 'dark'
                            ? '1px solid rgba(255, 255, 255, 0.05)'
                            : '1px solid rgba(0, 0, 0, 0.03)',
                        pt: 0.5,
                        pb: 0.5,
                    }}
                >
                    <DrawerCommonContent data={data}/>
                </Box>
            </Box>
        </Fade>
    );
};
//
export default DrawerContent;